/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  AiTextToFilterRequest,
  AiTextToFilterResponse,
  CountryCode,
  TextToFilterParams
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Converts a text to a search filter
 */
export const textToFilter = (
    aiTextToFilterRequest: AiTextToFilterRequest,
    params?: TextToFilterParams,
 options?: SecondParameter<typeof customInstance<AiTextToFilterResponse>>,) => {
      return customInstance<AiTextToFilterResponse>(
      {url: `/api/v1/ai/text-to-filter`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiTextToFilterRequest,
        params
    },
      options);
    }
  /**
 * @summary Returns a list of all rolled out countries for AI search
 */
export const rolledOutCountries = (

 options?: SecondParameter<typeof customInstance<CountryCode[]>>,) => {
      return customInstance<CountryCode[]>(
      {url: `/api/v1/ai/rolled-out-countries`, method: 'GET'
    },
      options);
    }
  export type TextToFilterResult = NonNullable<Awaited<ReturnType<typeof textToFilter>>>
export type RolledOutCountriesResult = NonNullable<Awaited<ReturnType<typeof rolledOutCountries>>>
